export const ADJUSTMENT_SERVICE_MENU = {
  EMPTY: 'EMPTY',
  PBBPP: 'PBBPP',
  BPHTB: 'BPHTB',
}